module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kqA14"))).then(() => parcelRequire('f4eak'));